export const host = 'https://enterpriseapp.up.railway.app'
// export const host = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_LIVE_URL
console.log('REACT_APP_LIVE_URL', process.env.REACT_APP_LIVE_URL) 

